module.exports = __webpack_public_path__ + "static/media/cover-image-v1.7c8b4b88.png";